import { Grid } from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Image } from "react-image-and-background-image-fade"
import kim_dental_logo from "../../images/kim-dental-logo.png"
import good_health from "../../images/good-health-and-well-being.png"

const KimDentalMapDetail = () => {
  return (
    <>
      <Grid container spacing={5}>
        <Grid item lg={3} xl={2}>
          <Image
            src={kim_dental_logo}
            width="532px"
            height="370px"
            isResponsive
            disableLoader
            alt="kim dental"
            style={{ backgroundSize: "cover", backgroundPosition: "center" }}
          />
          {/* <StaticImage
            src="../../images/kim-dental-logo.png"
            alt="Kim Dental"
            layout="fullWidth"
          /> */}
        </Grid>
      </Grid>
      <Grid container spacing={5} alignItems="flex-end">
        <Grid item lg={3} xl={2} container spacing={2}>
          <Grid item xs={6}>
            <Image
              src={good_health}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="life on land"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
            {/* <StaticImage
              src="../../images/life-on-land.png"
              alt="life on land"
              layout="fullWidth"
            /> */}
          </Grid>
          <Grid item xs={6}></Grid>
        </Grid>
        <Grid item lg={9} xl={10} container>
          <Grid item xs={12}>
            <StyledDetailHeader>Oral Healthcare</StyledDetailHeader>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailLocation>Based in Vietnam</StyledDetailLocation>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              borderBottom: "3px solid #0F6494",
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            container
            alignItems="center"
          >
            <Grid item xs={6}>
              <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
            </Grid>
            <Grid item xs={6}>
              <StyledDetailSubheaderContent>
                Better Healthcare & Education
              </StyledDetailSubheaderContent>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              About the Company
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Dental service provider operating a network of 19 clinics across
              six cities in Vietnam.
            </StyledDetailSubheaderContent>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              Impact Thesis
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Enhancing access to oral healthcare services and prevention
              efforts in Vietnam to reduce the risks of oral and
              non-communicable diseases.
            </StyledDetailSubheaderContent>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default KimDentalMapDetail
